import { containsText } from './contains-text.matcher';
import { hasText } from './has-text.matcher';
import { isDefined } from './is-defined.matcher';
import { isInstanceOf } from './is-instance-of.matcher';
import { notEmpty } from './not-empty.matcher';
import { notNull } from './not-null.matcher';
import { notUndefined } from './not-undefined.matcher';

export class Matchers {
  public static hasText = hasText;
  public static isDefined = isDefined;
  public static isInstanceOf = isInstanceOf;
  public static notEmpty = notEmpty;
  public static notNull = notNull;
  public static notUndefined = notUndefined;
  public static containsText = containsText;
}

export { hasText, isDefined, isInstanceOf, notEmpty, notNull, notUndefined, containsText };
